import { paths } from "@appretio/api";

type ResponseType =
  paths["/v1/in-season/review/get-review-data"]["post"]["responses"]["200"]["content"]["application/json"];

export const reviewDataResponse = {
  result: [
    {
      brand: "mama.licious",
      appretio_thumbnail_url:
        "https://media.cdn.bestseller.com/style/20021127/4608296/Qdzlvd59e3uP3_001/variations/mVlONXPpWEC7arOn1aLQfj3MYq7_thumbnail.png",
      style_option_number: 4608296,
      style_option_id_mockup: "20021127_Winetasting",
      style_number: 20021127,
      style_name: "VMMSABA RIB LS V-NECK BELT DRESS GA NOOS",
      style_variant_name: null,
      style_colour: "Winetasting",
      style_main_colour: "Winetasting",
      style_colour_hex_code: "#492A34",
      appretio_picture_url:
        "https://media.cdn.bestseller.com/style/20021127/4608296/Qdzlvd59e3uP3_001/variations/aKrw54LjrpH8ZVwNO76Asakpnr0V_preview.png",
      style_recommended_retail_price_eur: 39.99,
      seasonality: [
        0.432, 0.447, 0.415, 0.38, 0.377, 0.36, 0.323, 0.338, 0.354, 0.325,
        0.335, 0.303, 0.248, 0.219, 0.16, 0.126, 0.113, 0.137, 0.115, 0.163,
        0.209, 0.209, 0.215, 0.196, 0.201, 0.207, 0.239, 0.279, 0.399, 0.45,
        0.473, 0.512, 0.62, 0.647, 0.705, 0.78, 0.855, 0.859, 0.869, 0.856,
        0.772, 0.73, 0.625, 0.559, 0.574, 0.646, 0.636, 0.683, 0.703, 0.664,
        0.614, 0.634
      ],
      trend: [
        0.9403712699865022, 0.9519274093397849, 0.9709945658033711,
        0.9807948379877136, 0.9615324014847009, 0.9355208221091954,
        0.9237085481610394, 0.9265813801585462, 0.9303096843256947,
        0.9399389765019344, 0.9677744024779392, 0.955254144942996,
        0.921130262436762, 0.9157991596329519, 0.9174925149877551,
        0.9289784387572152, 0.9370751603139544, 0.9463236937303326,
        0.9608747321004716, 0.9605712720408508, 0.9625426412519668,
        0.978502409634295, 0.98593667400082, 0.9831157941266626,
        0.9906157320040282, 1.0, 0.9938219240079642, 0.9630198401677932,
        0.9223548372228996, 0.9045056353550527, 0.8825381546397854,
        0.8551360711973603, 0.8386024652705931, 0.8269287324118524,
        0.7868927660911331, 0.7505331493669964, 0.7757801167523418,
        0.8099354895071186, 0.8323856318004481, 0.832433143845535,
        0.8100172889497452, 0.7811413540168886, 0.7494448218814769,
        0.7457914924483744, 0.756058562792107, 0.7550769921147044,
        0.7583304414148824, 0.7559749793553423, 0.7387016804589918,
        0.6983750424360148, 0.6559964063417966, 0.6222027244826877,
        0.5907367581808787, 0.5632499972934653, 0.5328927775033703,
        0.5018323167399822, 0.4660816948722418, 0.4381414932566016,
        0.4195171447494238, 0.396166458198027, 0.3651221961234256,
        0.3566483889943114, 0.3460677106201949, 0.3150352155239003,
        0.2925569641013597, 0.278914765784217, 0.2791388633028458,
        0.2711038853817162, 0.2514267053071831, 0.228781097513757,
        0.2014397055655182, 0.1771209935985116, 0.1576787604824663,
        0.1467482005432675, 0.1346817071867902, 0.119538065658187,
        0.1068905111736142, 0.1037211156504547, 0.1074020859834153,
        0.1227993113274243, 0.1328026327665273, 0.1150369602673058,
        0.09908578461249569, 0.0926514428783958, 0.09410933085695194,
        0.1029942869643792, 0.1073808725864285, 0.1044154093047226,
        0.07852663673423443, 0.05361172938385761, 0.04750739704928526,
        0.03851449118816101, 0.03099009844512076, 0.03123192896479319,
        0.04789059725035821, 0.06542048667469981, 0.07328374325690847,
        0.0779991719003766, 0.08336485790145724, 0.0992827737495905,
        0.1078220338422721, 0.1081875710269256, 0.1308106344270874,
        0.1552322190887657, 0.1542160871929945, 0.1503432072147098,
        0.1501425773950492, 0.1553999442945095, 0.1675772780163798,
        0.1692886059473144, 0.1594488971313622, 0.1547299136624938,
        0.1600697281432155, 0.1621287815158253, 0.1687910796136594,
        0.1825096255253645, 0.1872184462308002, 0.1910341448860473,
        0.1936079929868165, 0.1927246264826031, 0.2025921272581495,
        0.2203959454836355, 0.2350917920711773, 0.243476623339998,
        0.2570824121166197, 0.2757117222958683, 0.2876148586357106,
        0.3062131638249875, 0.3206149255055452, 0.3224621109223349,
        0.3250062293962965, 0.321346618206248, 0.3255603089949068,
        0.3470095307001092, 0.3593672236842269, 0.3593975145184353,
        0.3483627915203236, 0.3358880646836529, 0.3363598629959234,
        0.3314286529664804, 0.3394499413697941, 0.355420501219736,
        0.3536227485110509, 0.3446717858939646, 0.3353404777425471,
        0.3216101736267298, 0.2964322530443521, 0.2692481976080724,
        0.2593817688062228, 0.2715736572424896, 0.2685580309417998,
        0.2616661303264247, 0.278561440466176, 0.2939625145662859,
        0.2893242527932121, 0.2822087844946232, 0.2913383678411682,
        0.2973846764242569, 0.2930679452451184, 0.2800518433680245,
        0.2649267956506265, 0.2627536697273523, 0.2622750234776104,
        0.2570079072268717, 0.2532221445049934, 0.2454123883671797,
        0.2324603979142474, 0.2199026448884063, 0.2086171545177686,
        0.1975233804742044, 0.1881212324261009, 0.1823239759487238,
        0.1769159221162434, 0.1679114858627501, 0.1566361100925947,
        0.1458274101289583, 0.1314842094830015, 0.1118563367291014,
        0.09016738467840574, 0.06935116260508657, 0.05946824279922366,
        0.05950828752549352, 0.05636653744621706, 0.04288143317244354,
        0.02735762317759878, 0.01211036985545633, 0.00248094183702912, 0.0,
        0.003067348137417494
      ],
      gs1: 203.4559974693364,
      gs2: 199.64100000000002,
      gis1: 6.0,
      ns3: 65.56,
      nis3: 2.0,
      gr2: 134.081,
      gir: 4.0,
      st: 1.0,
      week_zero_50_st: 2,
      time_purchase: 2.0,
      potential_nis: null,
      rank: null
    },
    {
      brand: "mama.licious",
      appretio_thumbnail_url:
        "https://media.cdn.bestseller.com/style/20019653/4384528/kLM3vm19z9SKg_001_variations/kLM3vm19z9SKg_001_thumbnail.png",
      style_option_number: 4384528,
      style_option_id_mockup: "20019653_SilverMink_1077498",
      style_number: 20019653,
      style_name: "VMMASTA LS CALF DRESS JERSEY",
      style_variant_name: "Detail:Melange",
      style_colour: "Silver Mink",
      style_main_colour: "Silver Mink",
      style_colour_hex_code: "#9F8D7C",
      appretio_picture_url:
        "https://media.cdn.bestseller.com/style/20019653/4384528/kLM3vm19z9SKg_001_variations/kLM3vm19z9SKg_001_preview.png",
      style_recommended_retail_price_eur: 34.99,
      seasonality: [
        0.413, 0.407, 0.383, 0.351, 0.338, 0.266, 0.216, 0.202, 0.197, 0.168,
        0.155, 0.161, 0.173, 0.161, 0.138, 0.115, 0.104, 0.067, 0.047, 0.072,
        0.11, 0.149, 0.147, 0.173, 0.174, 0.156, 0.122, 0.128, 0.15, 0.182,
        0.255, 0.346, 0.51, 0.558, 0.648, 0.717, 0.751, 0.735, 0.793, 0.787,
        0.732, 0.693, 0.65, 0.585, 0.643, 0.701, 0.695, 0.666, 0.644, 0.509,
        0.43, 0.396
      ],
      trend: [
        0.5013631638050958, 0.5155495826038071, 0.5487854132924114,
        0.5929371808558886, 0.617088429755733, 0.6279160920724313,
        0.6450684655002966, 0.6691222482869242, 0.6890474491899472,
        0.7020402382520232, 0.7114055816799724, 0.7212902133195657,
        0.7393600803965702, 0.7707282272753, 0.797965184466463,
        0.8196713652798023, 0.8383281004642781, 0.8419648148703214,
        0.8484723885473336, 0.8611868832399785, 0.8742645501999645,
        0.8856086886435794, 0.8954640454668304, 0.9145252143540922,
        0.929061210103034, 0.9285703419486483, 0.9338480526958488,
        0.9483273964927611, 0.9654507622352066, 0.9864502782156838,
        0.9935988474162424, 0.9982583807181211, 0.9946713188225011,
        0.9602394806957066, 0.9503438472798912, 0.9638171224785268,
        0.9717392025632784, 0.9919695764153794, 1.0, 0.9921677550792827,
        0.989016443593561, 0.9730241691346877, 0.933207968710416,
        0.8993249876082811, 0.8965447791383414, 0.9071458180613988,
        0.9214771999399309, 0.9139905546630684, 0.8971125480784333,
        0.8878131996801413, 0.8697642542992212, 0.8674924102647884,
        0.86883318585676, 0.8531609038120572, 0.8228214737429713,
        0.7953475803329633, 0.7912376860430689, 0.7927767927771456,
        0.787915401585282, 0.7847879044126824, 0.7885637795483037,
        0.8018977388937382, 0.8053350082698917, 0.8044949687006713,
        0.8047586160037107, 0.7879619587377091, 0.778005856498202,
        0.7782365859805681, 0.7749740429990244, 0.781039274608332,
        0.7898670170421982, 0.7986334361338169, 0.8061520959783907,
        0.818805383338472, 0.8373390810687013, 0.8535003574028031,
        0.8729211153289609, 0.887876945099186, 0.8847589337143728,
        0.881545912471106, 0.8837489615341678, 0.8810933962079173,
        0.8836870588838002, 0.891353035435471, 0.8984603922032784,
        0.908036679635269, 0.9180692212558335, 0.9241705712266973,
        0.9197360134941579, 0.9138070477102781, 0.919134963522579,
        0.9280540648531658, 0.9334978903962952, 0.9334933761443249,
        0.9440380558285332, 0.9568719059396641, 0.9523934648251048,
        0.9473437150918922, 0.9381665043896006, 0.944437409417091,
        0.9528559434183047, 0.9431774831380532, 0.9536812838835139,
        0.9581876036469252, 0.95482318408168, 0.9592044578698735,
        0.9521994781586439, 0.9425617546585782, 0.9347476325512409,
        0.9242241514343268, 0.9127665869230795, 0.8970689249696885,
        0.8782354077118337, 0.8612361170688801, 0.8535840081157693,
        0.8459422620360662, 0.8255787544864427, 0.8107316520586676,
        0.8026940111412995, 0.7917571155848621, 0.7792961624453472,
        0.7680211459598741, 0.7572376089133267, 0.7416348747071799,
        0.7283329024503555, 0.7093307709252754, 0.6836822993684689,
        0.6621555854079242, 0.6469752842373881, 0.638145584508308,
        0.6329942255263009, 0.6175174736069368, 0.5985975056719915,
        0.5850473711550421, 0.5679231936882173, 0.5467046301237617,
        0.5308898788362809, 0.5193856919185752, 0.4886326844118328,
        0.4507694248224918, 0.4349676663895599, 0.4241076914014277,
        0.4013470129900792, 0.371742321031685, 0.3520342290727698,
        0.3437941805183801, 0.3246404065065179, 0.3012712042158861,
        0.2834941971897909, 0.2687019413526947, 0.2388570228990603,
        0.2084328926331946, 0.2070246797720262, 0.207446355936157,
        0.2001078844399641, 0.1984922785591318, 0.1940733593261174,
        0.1887488228880528, 0.1766783515400081, 0.1621927474079241,
        0.15644202936313, 0.1526656973618164, 0.1502001717660492,
        0.1472044561326484, 0.1422071028366538, 0.1313181936665031,
        0.1165367108926553, 0.107171374807738, 0.1153684185759983,
        0.1254493026788094, 0.1154898700958982, 0.1014073304522076,
        0.1016802410808493, 0.1011288360435192, 0.08861140778203752,
        0.07672587650588396, 0.06820913830901211, 0.06110497147977277,
        0.05195622014629754, 0.03696108523514945, 0.02351691788888333,
        0.01315754602735427, 0.002721481070292998, 0.0, 0.0006288959694139322,
        0.005011941565293711, 0.01515664520224779, 0.03378425463230118,
        0.05002049432939035
      ],
      gs1: 1419.0489761067945,
      gs2: 1410.2223,
      gis1: 48.0,
      ns3: 677.5968999999999,
      nis3: 23.0,
      gr2: 732.6253999999999,
      gir: 25.0,
      st: 0.377049,
      week_zero_50_st: 10,
      time_purchase: 61.0,
      potential_nis: null,
      rank: null
    },
    {
      brand: "mama.licious",
      appretio_thumbnail_url:
        "https://media.cdn.bestseller.com/style/20021111/4608113/7AWV7AnDYZFpA_001/variations/BeprBE3vaMUvNXKL1ejkuYnn966_thumbnail.png",
      style_option_number: 4608113,
      style_option_id_mockup: "20021111_Birch_1143988",
      style_number: 20021111,
      style_name: "VMMRAIN LS O-NECK BLK DRESS ENT",
      style_variant_name: "Stripes:W. black",
      style_colour: "Birch",
      style_main_colour: "Birch",
      style_colour_hex_code: "#DDD5C7",
      appretio_picture_url:
        "https://media.cdn.bestseller.com/style/20021111/4608113/7AWV7AnDYZFpA_001/variations/7wXjeXjO8etlGZPmdNkrUa84QV8_preview.png",
      style_recommended_retail_price_eur: 34.99,
      seasonality: [
        0.423, 0.405, 0.404, 0.363, 0.355, 0.341, 0.301, 0.25, 0.201, 0.162,
        0.159, 0.158, 0.142, 0.149, 0.136, 0.105, 0.077, 0.067, 0.121, 0.114,
        0.099, 0.149, 0.245, 0.213, 0.217, 0.23, 0.322, 0.255, 0.262, 0.315,
        0.348, 0.247, 0.258, 0.232, 0.214, 0.224, 0.254, 0.322, 0.378, 0.38,
        0.4, 0.441, 0.416, 0.432, 0.476, 0.479, 0.45, 0.546, 0.642, 0.73, 0.809,
        0.943
      ],
      trend: [
        0.03177375257835391, 0.0, 0.01105947551364043, 0.021007882594816,
        0.03644777733070251, 0.06613993556333393, 0.08707131795393139,
        0.1035711975161925, 0.1134685209912778, 0.1204413080176916,
        0.1332631679414484, 0.1457146717210505, 0.1512444094778707,
        0.1560589767494262, 0.1619335288473562, 0.1684354201813538,
        0.1786934277207645, 0.1882485348567655, 0.1949041778287018,
        0.2010106720351669, 0.2115762141516839, 0.2190885091649682,
        0.2190885091649682, 0.23912129586706, 0.3017237543110968,
        0.3668303110928953, 0.3943753928082715, 0.3993835894837945,
        0.4619860479278313, 0.5251376551373391, 0.5256868039028103,
        0.5407113939293792, 0.5582400822937092, 0.5612933293969421,
        0.5629407756933554, 0.56513737075524, 0.5695305295777795,
        0.5762740037989126, 0.5983313540070847, 0.6406777749484541,
        0.6844540673419145, 0.714085955057679, 0.7525340426586654,
        0.819722214653652, 0.8759578570015482, 0.9198184331716022,
        0.964438982319639, 0.985069872909705, 1.0, 0.9871178413882696,
        0.9297551502870582, 0.8499867429904439, 0.7799331312675574,
        0.760664699715602, 0.7576788858938774, 0.7601251291262727,
        0.7690702431240458, 0.7600877450248177, 0.743001170872634,
        0.7284816105289476, 0.7180419619563615, 0.7155562217895388,
        0.7092281305307965, 0.697945727662637, 0.6913714678866776,
        0.6866256694157231, 0.6861321011995865, 0.6857949452258723,
        0.6774339799846911, 0.6737425738538438, 0.6758623974342106,
        0.6754848733085637, 0.7013393286818149, 0.7346154369687695,
        0.7447265227984577, 0.7283556825536643, 0.6706349325178644,
        0.6104448378991082, 0.5852034108399244, 0.5843247696850477,
        0.5269363134986687, 0.4689236012473004, 0.4833718156558253,
        0.485984656550632, 0.4772996600902057, 0.4793473000548574,
        0.4904598743775242, 0.504372297745652, 0.5101527333075571,
        0.5214596199972142, 0.520899503281024, 0.5096616849352784,
        0.5031133103273959, 0.4983365335989992, 0.4796627642225696,
        0.4429603732081637, 0.427455807097424, 0.423654468962759,
        0.4265036737864572, 0.4630354925098053, 0.4952070189994099,
        0.4973602743793133, 0.5022585469393661, 0.5129264665480315,
        0.5190209623877196, 0.5168853402233173, 0.5171182393905999,
        0.513076026156013, 0.4904667475383724, 0.4766984650706245,
        0.4835753518381171, 0.5072066138554556, 0.5332749714903516,
        0.5418878870017173, 0.5420296711728888, 0.5569577832228264,
        0.577376712322302, 0.5868989792519358, 0.5907618761228975,
        0.6019187867984364, 0.6201192558840838, 0.6266478930750567,
        0.6231846452083453, 0.6211157648528136, 0.5878731968763657,
        0.552432449101496, 0.5531685647794414, 0.5630492412174314,
        0.5673296361195405, 0.5675539975987852, 0.5717802346488957,
        0.5774081226267923, 0.5929975130767757, 0.6177066880721352,
        0.6390443217818633, 0.6599731548795928, 0.6913029390206417,
        0.7300066778395389, 0.7522660708427222, 0.7624828987571639,
        0.7858273142378955, 0.8067336796963537, 0.8169526488326057,
        0.8171565377456322, 0.813363891345813, 0.8151853312159838,
        0.8144267366777148, 0.7962903286692629, 0.77319754007401,
        0.7605598623637064, 0.7370145524266443, 0.7066695907159031,
        0.6947648574771959, 0.6803876981202563, 0.6490890552053727,
        0.6247785401525136, 0.6152480590443774, 0.6151155230076845,
        0.6147754937336272, 0.615109593204347, 0.620415685876035,
        0.6228763828745917, 0.6207208515965847, 0.610368246837187,
        0.6004604146940057, 0.6026532550977586, 0.6105669173898234,
        0.6057525023876672, 0.5916446937160256, 0.5931624728905361,
        0.6010803564456525, 0.5940848684994186, 0.5874845798518779,
        0.5918481941664618, 0.6037803212316446, 0.6207009983946755,
        0.631624232338517, 0.6405003417445935, 0.646955167457294,
        0.6459193263124139, 0.6492986400785797, 0.6605761724630146,
        0.6829258346339817, 0.7033261530660203, 0.6963466313193376,
        0.6748862193479996, 0.6522352205875627, 0.6329304982442079,
        0.6201194089789591
      ],
      gs1: 770.6501200344817,
      gs2: 757.4268999999999,
      gis1: 26.0,
      ns3: 369.06999999999994,
      nis3: 13.0,
      gr2: 388.3569,
      gir: 13.0,
      st: 0.52,
      week_zero_50_st: 3,
      time_purchase: 25.0,
      potential_nis: null,
      rank: null
    },
    {
      brand: "mama.licious",
      appretio_thumbnail_url:
        "https://media.cdn.bestseller.com/style/20018348/4192208/ZpQk54E5Zqsna_001_variations/ZpQk54E5Zqsna_001_thumbnail.png",
      style_option_number: 4192208,
      style_option_id_mockup: "20018348_Black",
      style_number: 20018348,
      style_name: "VMMLAVENDER 2FUNCTION LS DRESS GA NOOS",
      style_variant_name: null,
      style_colour: "Black",
      style_main_colour: "Black",
      style_colour_hex_code: "#000000",
      appretio_picture_url:
        "https://media.cdn.bestseller.com/style/20018348/4192208/ZpQk54E5Zqsna_001_variations/ZpQk54E5Zqsna_001_preview.png",
      style_recommended_retail_price_eur: 26.99,
      seasonality: [
        0.312, 0.318, 0.3, 0.27, 0.256, 0.225, 0.182, 0.183, 0.158, 0.126,
        0.096, 0.086, 0.062, 0.066, 0.056, 0.055, 0.055, 0.034, 0.026, 0.035,
        0.042, 0.029, 0.037, 0.043, 0.049, 0.079, 0.11, 0.135, 0.182, 0.226,
        0.267, 0.368, 0.522, 0.545, 0.618, 0.706, 0.73, 0.74, 0.836, 0.871,
        0.825, 0.789, 0.739, 0.666, 0.691, 0.769, 0.803, 0.776, 0.756, 0.643,
        0.553, 0.478
      ],
      trend: [
        1.0, 0.9936292012576265, 0.991248216369423, 0.9896751393372466,
        0.9772566455617417, 0.9601817272281291, 0.9421378921359461,
        0.9375273641989648, 0.9487927123417842, 0.9515807488261084,
        0.9332017443858184, 0.9185619130382991, 0.9263704550725106,
        0.932825322326691, 0.927911801757885, 0.924994888715142,
        0.9295991126031431, 0.9205147381082392, 0.9080804019177093,
        0.9060620490217806, 0.901071673487801, 0.9017525753649615,
        0.9038262612963919, 0.8986964975921788, 0.8864494888330098,
        0.8734754716873742, 0.8675604498817028, 0.8626131825376415,
        0.8591103149154063, 0.860141513518431, 0.8529140330225328,
        0.8449667346710996, 0.8266376893747638, 0.7928949894998449,
        0.761496697138765, 0.7413103793225562, 0.7272271052378988,
        0.7195866229285101, 0.7192003598941902, 0.7050783987360533,
        0.6865545397290117, 0.6670175803339621, 0.6394160412360524,
        0.6269577635179329, 0.6305590291757386, 0.63989384061229,
        0.6549907488329465, 0.6431267474376513, 0.637944483207598,
        0.6474617936543328, 0.6371201532470282, 0.6289468044727723,
        0.623371677852367, 0.6142667096020464, 0.6084791450454188,
        0.604345232785787, 0.5989944696789979, 0.5985672858226057,
        0.6002366223039826, 0.6028412738589713, 0.5982236578103028,
        0.5986991962073948, 0.6039891869990333, 0.601468344535218,
        0.5952692386124034, 0.5814961655212997, 0.5724618071496131,
        0.5716353748905932, 0.5688137766878991, 0.5693557506791719,
        0.5710430498963429, 0.566461810425334, 0.5622016234748324,
        0.5582838361241336, 0.5611506463376197, 0.5685933275012454,
        0.569719391677111, 0.570205959534095, 0.577278143163215,
        0.5884029230290447, 0.5912847547203192, 0.587652109092946,
        0.5918814487811993, 0.6012509818034616, 0.6108984642348901,
        0.612256502865214, 0.6113524903350512, 0.6147426777264183,
        0.6095102365749946, 0.6025662936514925, 0.5984412596784734,
        0.6049245877870959, 0.6057503002612883, 0.6006452712547616,
        0.6179841229597653, 0.6308656390285995, 0.6265018544053851,
        0.6222929374452829, 0.603829969972122, 0.6024645468030746,
        0.5997027155231298, 0.5710071386347967, 0.5712990631053736,
        0.5813574704111649, 0.5821082340006993, 0.5838663879641732,
        0.5798917712838397, 0.582949081290361, 0.5957272049409198,
        0.600920518051759, 0.605136493211535, 0.6063628676306297,
        0.6044301857260213, 0.6078849420878035, 0.6146481403161105,
        0.6215459283518051, 0.6207728003122074, 0.6236548016852689,
        0.632488558433674, 0.6364899683502712, 0.6367951648182746,
        0.6386185431412809, 0.6396530136920957, 0.6377480181380016,
        0.6386006459063345, 0.6407982994502761, 0.6339319593461789,
        0.6282000007610573, 0.6336317613637851, 0.6352824306184551,
        0.6297393741139401, 0.6120929804747167, 0.596880936790163,
        0.5906275584487704, 0.5836119044564554, 0.5721482626892818,
        0.5548437109844572, 0.5512988868406522, 0.5461890794247468,
        0.53369689965503, 0.5347757920021783, 0.5395829163127153,
        0.5328113227955793, 0.5131306926890156, 0.4945059194505061,
        0.4647584990926811, 0.4161797763466628, 0.3748141413982982,
        0.3414542424484998, 0.3183506400968656, 0.2915780612063439,
        0.2611959476273367, 0.2548929438647186, 0.2510662885931041,
        0.2341812742168676, 0.2115110450747417, 0.1886352744919239,
        0.1814444398556321, 0.1727697752935555, 0.1503798935542272,
        0.1266101516320219, 0.1046079461905631, 0.08823952934918525,
        0.07563713330409935, 0.06746336756802261, 0.054880410867822,
        0.04057419589955197, 0.03382906801386414, 0.03207479481449371,
        0.03155114409608076, 0.02282054884591419, 0.01302629770932892,
        0.01391122831928428, 0.01383189045518799, 0.005343515947675219,
        0.0004331449449855086, 0.001433030245951103, 0.001448522203895768, 0.0,
        0.006275761443180527, 0.01737417848827959, 0.0229798184906525,
        0.02381941413999182, 0.02831180377456628, 0.03015470992303016,
        0.02593505246373838, 0.02528502451243332, 0.02078172496704785,
        0.01149787922869703
      ],
      gs1: 22.305785123966942,
      gs2: 22.31,
      gis1: 1.0,
      ns3: 22.31,
      nis3: 1.0,
      gr2: 0.0,
      gir: 0.0,
      st: 0.1,
      week_zero_50_st: 12,
      time_purchase: 10.0,
      potential_nis: null,
      rank: null
    },
    {
      brand: "mama.licious",
      appretio_thumbnail_url:
        "https://media.cdn.bestseller.com/style/20021116/4608140/7AWV7AnDYzSp6_001_variations/7AWV7AnDYzSp6_001_thumbnail.png",
      style_option_number: 4608140,
      style_option_id_mockup: "20021116_Black",
      style_number: 20021116,
      style_name: "VMMLIMONE LS HIGHNECK CALF DRESS GA",
      style_variant_name: null,
      style_colour: "Black",
      style_main_colour: "Black",
      style_colour_hex_code: "#000000",
      appretio_picture_url:
        "https://media.cdn.bestseller.com/style/20021116/4608140/7AWV7AnDYzSp6_001_variations/7AWV7AnDYzSp6_001_preview.png",
      style_recommended_retail_price_eur: 49.99,
      seasonality: [
        0.212, 0.195, 0.199, 0.226, 0.246, 0.26, 0.298, 0.345, 0.3, 0.288,
        0.271, 0.274, 0.257, 0.235, 0.202, 0.161, 0.105, 0.033, 0.061, 0.067,
        0.205, 0.374, 0.478, 0.545, 0.643, 0.591, 0.51, 0.51, 0.542, 0.553,
        0.553, 0.542, 0.531, 0.485, 0.446, 0.444, 0.445, 0.435, 0.413, 0.407,
        0.425, 0.416, 0.409, 0.465, 0.542, 0.588, 0.621, 0.744, 0.811, 0.719,
        0.714, 0.759
      ],
      trend: [
        0.4123144905904405, 0.4144829543934002, 0.4219176558347562,
        0.4240861196377158, 0.4281132351029923, 0.4485585929726555,
        0.4690039508423186, 0.4857319737899851, 0.5024599967376514,
        0.5139217820469215, 0.5198075807718777, 0.5272422822132338,
        0.5390138638644649, 0.5545027804376931, 0.5768068215670357,
        0.5864099552139888, 0.5848610840949517, 0.5867197673546315,
        0.590437102276628, 0.5941544371986248, 0.5997304553803011,
        0.6071651568216571, 0.6108825233410164, 0.6145998898603757,
        0.6164585731200554, 0.6164585731200554, 0.620175908042052,
        0.6257519262237284, 0.6276106094834081, 0.6170781658039779,
        0.5861003642548847, 0.5479976576063966, 0.5241447453580167,
        0.5198078335507788, 0.5216664852130959, 0.5216665010117771,
        0.5160904986287821, 0.5105144804471058, 0.5086558287847887,
        0.4993625072784783, 0.4863518192528086, 0.4770584661491356,
        0.4628086875477087, 0.4485589089462819, 0.4448415740242852,
        0.4299722343362984, 0.3983748717006452, 0.3689459570692703,
        0.3525277304635651, 0.320930367827912, 0.2614529774786023,
        0.2261382799209524, 0.2168449268172794, 0.2094102253759234,
        0.2019755239345674, 0.1945408224932113, 0.1852474693895383,
        0.1666607947795549, 0.1480741201695714, 0.131346097221905,
        0.1164767575339182, 0.1053247527679281, 0.09789005132657214,
        0.09045534988521614, 0.07868376823398483, 0.06319485166075688,
        0.04089081053141414, 0.02602143924606473, 0.02230407272670541,
        0.02044538946702575, 0.01672805454502906, 0.01301071962303237,
        0.007434701441356024, 0.0, 0.0205883043382268, 0.07277397131210678,
        0.1219571936936217, 0.1608462797047046, 0.1984485947198131,
        0.2327999360867458, 0.2720838785400051, 0.3083613556365041,
        0.3337134758491984, 0.3568044808923447, 0.3787610097135161,
        0.3994222723620687, 0.428797902555263, 0.4519019383507603,
        0.4623593222079978, 0.4820754036676951, 0.5058337939451106,
        0.5273062338297554, 0.545583051975011, 0.5660459692012474,
        0.5908637464144102, 0.6168471525921703, 0.6437936557870406,
        0.6676959749422307, 0.6973637478591184, 0.7300993689833324,
        0.7511280374006006, 0.7659756903007049, 0.7858656244637524,
        0.8062740502827322, 0.8175542525705642, 0.8249074350983452,
        0.8343666719646934, 0.8444514869094291, 0.8536023620394874,
        0.8611233950960893, 0.8698412728925735, 0.8798057790944865,
        0.8885356015506516, 0.8960798846412544, 0.9064967712562413,
        0.9189190139303838, 0.9288082129320142, 0.940710680399253,
        0.95205465696739, 0.9596310409630247, 0.965750248128068,
        0.9716021348150035, 0.976876004913476, 0.9825314511680165,
        0.9912043101852204, 1.0, 0.9826738372071143, 0.9344232793199122,
        0.8907793926665951, 0.8581127623645612, 0.8245126497989259,
        0.7932841302375286, 0.7613539812876906, 0.7353838410779782,
        0.7201661319771328, 0.7066233118310861, 0.6962695925393476,
        0.6854811624333903, 0.665829260647276, 0.6498139698669684,
        0.6503941979066248, 0.6527929852595342, 0.6460706787961142,
        0.6366467841683118, 0.6319222161234188, 0.624510783365364,
        0.6113611954265257, 0.5978531944492059, 0.5868017936999536,
        0.5817980908556981, 0.568122382827651, 0.5558677292280251,
        0.5557424900877477, 0.5514380661718072, 0.5441804136835667,
        0.5396606296016693, 0.5431064304452394, 0.5490862640821285,
        0.5491088921831864, 0.5471484992052495, 0.5447229419019383,
        0.5410332966224232, 0.5369300924690255, 0.533538447970487,
        0.5296440787209726, 0.5228778053518521, 0.5155251664193791,
        0.5104156305915428, 0.506816730035963, 0.5016077995019562,
        0.4968509335942323, 0.4939803743526031, 0.4935375716265878,
        0.4943547049323911, 0.4942875420903132, 0.4941106097608831,
        0.4918471399267072, 0.4891859529254634, 0.4878364896244966,
        0.4873253380710726, 0.4893154542099095, 0.4914189244990663,
        0.4914397867211309, 0.4911478578976164, 0.4907913199327997,
        0.4897714755568095, 0.4902149331355746, 0.4924828960889024,
        0.4925311416758518
      ],
      gs1: 1746.5549121788572,
      gs2: 1299.15304,
      gis1: 42.0,
      ns3: 715.77114,
      nis3: 23.0,
      gr2: 583.3819,
      gir: 19.0,
      st: 0.179688,
      week_zero_50_st: 34,
      time_purchase: 128.0,
      potential_nis: null,
      rank: null
    }
  ]
} satisfies ResponseType;

// Helper function to randomize style option to have unique entries
function randomizeStyleOption(data: typeof reviewDataResponse.result) {
  return data.map((item) => ({
    ...item,
    style_option_number:
      item.style_option_number * Math.floor(Math.random() * 1000),
    style_option_id_mockup: `${item.style_option_id_mockup}_${Math.random().toString(36).substring(2, 10)}`
  }));
}

export const largeTableDataResponse = {
  result: [
    ...randomizeStyleOption(reviewDataResponse.result),
    ...randomizeStyleOption(reviewDataResponse.result),
    ...randomizeStyleOption(reviewDataResponse.result),
    ...randomizeStyleOption(reviewDataResponse.result),
    ...randomizeStyleOption(reviewDataResponse.result),
    ...randomizeStyleOption(reviewDataResponse.result),
    ...randomizeStyleOption(reviewDataResponse.result),
    ...randomizeStyleOption(reviewDataResponse.result),
    ...randomizeStyleOption(reviewDataResponse.result),
    ...randomizeStyleOption(reviewDataResponse.result)
  ]
} satisfies ResponseType;
